import PropTypes from "prop-types";
import Link from "next/link";
import { removeHtmlTag } from "../../helpers/Helper";
import NextImage from "@components/Image/NextImage";
import styles from "./VCard.module.css";

const formatCategories = (props) => {
  let categories = props.categories;
  if (categories) {
    return categories.map((category, index) => {
      return (
        <span className="category" key={`category-${index}`}>
          {category.replace(/-/g, " ").replace("&", "and")}
        </span>
      );
    });
  } else {
    return null;
  }
};

const formatTag = (props) => {
  let tags = props.tags;
  if (tags) {
    return (
      <span className="category">{tags[0]?.name.replace(/\b\w/g, (l) => l.toUpperCase())}</span>
    );
  }
};

const renderByline = (authorByline, i, propsByline, displayName, cAuthorNameClasses) => {
  let seperator = "";
  if (displayName) {
    if (i > 0 && i === propsByline.length - 1) {
      seperator = <span>&nbsp;&&nbsp;</span>;
    } else {
      if (i) {
        seperator = ", ";
      }
    }
    return (
      <span key={`byline-${i}`}>
        {seperator}
        <Link href={"/author/" + encodeURIComponent(displayName)}>
          <span className={`${styles.cAuthorName} ${cAuthorNameClasses}`}>{displayName}</span>
        </Link>
      </span>
    );
  }
};
const VCard = (props) => {
  let author = "";
  let displayName = "";
  let hoverTitle = removeHtmlTag(props.title);
  if (!props.noAuthor) {
    author = (
      <>
        <p className={`${styles.author} ${props.authorClasses}`}>
          <span>By&nbsp;</span>
          {props.byline.map((byline, i) => {
            displayName = byline.display_name || byline.Display_Name;
            return renderByline(byline, i, props.byline, displayName, props.cAuthorNameClasses);
          })}
        </p>
      </>
    );
  }
  return (
    <div
      className={`${styles["v-card"]} ${props.vCardClasses} ${props.className} ${styles[props.className]}`}
    >
      <div className={`${styles.image} ${props.imageClasses}`}>
        {props.isCategoryPage ? (
          <a href={props.slug}>
            {!props.checked && props.tags ? (
              <p
                className={`${styles.tagLink} ${styles.categoryOther} ${props.tagLinkCategoryClasses}`}
              >
                {props.tags ? formatTag(props) : formatCategories(props)}
              </p>
            ) : (
              ""
            )}
            <NextImage
              ImageUrl={props.image ? props.image : ""}
              key={"Image" + hoverTitle}
              Title={hoverTitle}
              Alt_Text={hoverTitle}
              className={"v-card-img-top " + props.className}
              isLazyload={props.checked ? false : props.isLazyLoadImage}
              fetchpriority={props.checked}
              height={190}
              width={320}
            />
          </a>
        ) : (
          <Link href={props.slug}>
            {props.tags != null ? (
              <p
                className={`${styles.tagLink} ${styles.categoryOther} ${props.tagLinkCategoryClasses}`}
              >
                {props.tags ? formatTag(props) : formatCategories(props)}
              </p>
            ) : (
              ""
            )}
            <NextImage
              ImageUrl={props.image && props.image ? props.image : ""}
              Title={hoverTitle}
              Alt_Text={hoverTitle}
              className={"v-card-img-top " + props.className}
              Layout="responsive"
              Sizes="(min-width: 520px) 21rem, 15rem"
              Heights="(min-width:520px) 35rem, 20rem"
              isLazyload={props.isLazyLoadImage}
              height={190}
              width={320}
            />
          </Link>
        )}
      </div>
      <div className={`${props.contentClasses} ${styles.content}`}>
        <Link href={props.slug}>
          <h3 title={hoverTitle}>
            <span dangerouslySetInnerHTML={{ __html: props.title }} />
          </h3>
        </Link>
        {props.subTitle != "" ? (
          <p>
            <span dangerouslySetInnerHTML={{ __html: props.subTitle }} />
          </p>
        ) : (
          <></>
        )}
        {displayName ? (
          props.isCategoryPage && props.byline.length != 0 ? (
            <div className={props.categoryAuthorClasses}>
              {props.checked ? (
                <Link
                  href={props.slug}
                  className={`${styles.cAuthorName} ${props.cAuthorNameClasses}`}
                >
                  {props.tags ? formatTag(props) : formatCategories(props)}
                </Link>
              ) : (
                ""
              )}
              {author}
            </div>
          ) : (
            <></>
          )
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default VCard;

VCard.propTypes = {
  title: PropTypes.string,
  image: PropTypes.string,
  subTitle: PropTypes.string,
  byline: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  categories: PropTypes.array,
  slug: PropTypes.string,
  tags: PropTypes.array,
  noAutor: PropTypes.bool,
  isLazyLoadImage: PropTypes.bool,
};
